/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Modal from '../..';
import Icon from '@components/icon-component';
import { settingsActions } from '@redux/slices/settings';
import { cacheActions } from '@redux/slices/cache';

import style from './style.module.scss';

const TimeToSyncModal = ({
  open,
  setOpen,
  lastSyncTime,
  pendingSync = true,
  limitExceeded = false,
  syncNowEvent = null,
  refreshDataOnlyEvent = null,
  isSettingUpdated = false,
  sendingAgainPhotosAndDocuments,
  showSnoozeOption = false
}) => {
  const dispatch = useDispatch();
  const { syncReminderFrequency = 0 } = useSelector((state) => state.settings);
  return (
    <Modal
      open={open}
      setOpen={() => {
        if (syncReminderFrequency) {
          dispatch?.(settingsActions.setSyncReminderFrequency(0));
          dispatch?.(cacheActions.updateSyncingReminder(false));
          dispatch?.(settingsActions.setLastSynReminder(moment().format()));
        }

        setOpen();
      }}
      icon={'sync-time'}
      statusText={pendingSync ? 'Time to sync?' : 'Time to refresh data?'}
      modalTextUpper={() => (
        <>
          {!showSnoozeOption && (
            <>
              It has been{' '}
              <span
                style={{
                  color: limitExceeded ? '#E02B2B' : '',
                  fontWeight: limitExceeded ? 'bold' : ''
                }}
              >
                {' '}
                {lastSyncTime}
              </span>{' '}
              since you’ve refreshed data.
              <br />
            </>
          )}
          {pendingSync ? (
            <>
              {!showSnoozeOption && <br />}
              You have <b>{pendingSync} records</b> that are{' '}
              <Link
                className="link"
                onClick={() => setOpen(false)}
                to={'/task-records?status=Pending sync'}
              >
                pending sync
              </Link>
              .<br />
            </>
          ) : (
            ''
          )}
          {isSettingUpdated ? (
            <>
              {(!showSnoozeOption || pendingSync) && <br />}
              <span
                className={style.settingSync}
                style={{
                  marginTop: '100px'
                }}
              >
                This will also sync your recent settings or bookmark changes.
              </span>
            </>
          ) : (
            <></>
          )}
          {sendingAgainPhotosAndDocuments ? (
            <>
              {(!showSnoozeOption || pendingSync || isSettingUpdated) && <br />}
              {sendingAgainPhotosAndDocuments && pendingSync ? (
                <div style={{ marginBottom: '14px' }}>
                  <Icon name={'line'} />
                </div>
              ) : (
                <></>
              )}
              <span
                className={style.settingSync}
                style={{
                  marginTop: '100px'
                }}
              >
                {!pendingSync
                  ? `Some photos/documents didn’t make it through in the last sync. Retry to send these now.`
                  : `This will also retry sending any photos and documents that failed during the last sync.`}
              </span>
            </>
          ) : (
            <></>
          )}
        </>
      )}
      textBtn={'Close'}
      progressData={
        sendingAgainPhotosAndDocuments && pendingSync
          ? ''
          : 'Ensure your internet connection is stable before syncing.'
      }
      sendingAgainPhotosAndDocuments={sendingAgainPhotosAndDocuments && pendingSync ? true : false}
      modalTextUpperClass={style.modalTextUpper}
    >
      <div>
        {pendingSync ? (
          <div className={style.modalBtn}>
            <button className="btn-fill button-large modal-btn-height" onClick={syncNowEvent}>
              Sync now
            </button>
          </div>
        ) : (
          ''
        )}

        {sendingAgainPhotosAndDocuments && !pendingSync ? (
          <div className={style.modalBtn}>
            <button className="btn-fill button-large modal-btn-height" onClick={syncNowEvent}>
              RETRY SYNC
            </button>
          </div>
        ) : (
          ''
        )}
        {/* btn-${ pendingSync || sendingAgainPhotosAndDocuments ? 'border' : 'fill'} */}
        <div className={style.modalBtn}>
          <button
            className={` btn-border-light-background button-large modal-btn-height`}
            onClick={refreshDataOnlyEvent}
            style={{
              lineHeight: '23px'
            }}
          >
            Refresh data only
          </button>
        </div>

        {showSnoozeOption && (
          <div className={style.modalBtn}>
            <button
              className={`btn-border button-large modal-btn-height`}
              onClick={() => {
                setOpen();
                dispatch?.(settingsActions.setSnoozeTimeStartTime(moment().format('HH:mm:ss')));
              }}
            >
              <div className={style.snoozeBtn}>
                <Icon name={'snooze-icon'} />
                <span> Snooze for 1 hour</span>
              </div>
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TimeToSyncModal;
